module.exports = __webpack_public_path__ + "static/img/img_password_text.66daecd.png";


//////////////////
// WEBPACK FOOTER
// ./static/login/img_password_text.png
// module id = wKQw
// module chunks = 83